
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/makeup-recommendations/nose-contour",
      function () {
        return require("private-next-pages/makeup-recommendations/nose-contour.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/makeup-recommendations/nose-contour"])
      });
    }
  